import xss from 'xss';

const sanitizeHTML = (unsafeHTML) => (unsafeHTML);

export default sanitizeHTML;
